"use strict";

require("core-js/modules/es.array.iterator");

var curry = require("../Strict/curry.js");

var ipp = require("./zipWithIndexL.js");

var rejectL = require("./rejectL.js");

var mapL = require("./mapL.js");

var last = require("../Strict/last.js");

var go = require("../Strict/go.js");

module.exports = curry(function removeL(start, count, iter) {
  if (count < 1) return iter;
  return go(iter, ipp, rejectL(([i]) => i >= start && i < start + count), mapL(last));
});